import request from "@/api";

//任务
export function listProjectTask(data) {
    return request({
        url: '/api/project/task/getProjectTaskList',
        method: 'get',
        params: data
    })
}
export function saveProjectTask(data) {
    return request({
        url: '/api/project/task/saveProjectTask',
        method: 'post',
        data: data
    })
}
export function getProjectTaskInfo(data) {
    return request({
        url: '/api/project/task/getProjectTaskInfo',
        method: 'get',
        params: data
    })
}

export function deleteProjectTask(data) {
    return request({
        url: '/api/project/task/deleteProjectTask',
        method: 'post',
        data: data
    })
}

export function moveProjectTask(data) {
    return request({
        url: '/api/project/task/moveProjectTask',
        method: 'post',
        data: data
    })
}

export function copyProjectTask(data) {
    return request({
        url: '/api/project/task/copyProjectTask',
        method: 'post',
        data: data
    })
}


//任务附件
export function listProjectTaskAttachment(data) {
    return request({
        url: '/api/project/task/getProjectTaskAttachmentList',
        method: 'get',
        params: data
    })
}
export function saveProjectTaskAttachment(data) {
    return request({
        url: '/api/project/task/saveProjectTaskAttachment',
        method: 'post',
        data: data
    })
}

export function downloadProjectTaskAttachment(data) {
    return request({
        url: '/api/project/task/download',
        method: 'post',
        data: data
    })
}

export function deleteProjectTaskAttachment(data) {
    return request({
        url: '/api/project/task/deleteProjectTaskAttachment',
        method: 'post',
        data: data
    })
}

//任务日志
export function listProjectTaskLog(data) {
    return request({
        url: '/api/project/task/getProjectTaskLogList',
        method: 'get',
        params: data
    })
}